import { NoDataDisplayV2, Text } from '@pukka/ui-components';

import warning from './warning.svg';

function OldDataDisplay() {
  return (
    <NoDataDisplayV2
      isLoading={false}
      title="Data you're looking for is not available in Backoffice"
      imageSource={warning}
      imageSize={100}
      className="m-auto w-full max-w-144 whitespace-normal"
      placeholder={
        <Text weight="normal">
          You can only access last year&apos;s full-year data up to present. If you need help, please contact Support via Whatsapp{' '}
          <Text as="a" href="tel:+6281110679900" weight="semibold" className="text-blue-300 underline">
            +6281110679900
          </Text>{' '}
          or email to{' '}
          <Text as="a" href="mailto:support@mokapos.com" weight="semibold" className="text-blue-300 underline">
            support@mokapos.com
          </Text>
          .
        </Text>
      }
    />
  );
}

export { OldDataDisplay };
